export const LAYER_NAMES = {
	//CHOROPLETH LAYERS
	//TOP
	COUNTRY_OUTLINE_LAYER: 'COUNTRY_OUTLINE_LAYER',
	STATE_OUTLINE_LAYER: 'STATE_OUTLINE_LAYER',
	CHOROPLETH_COUNTRY_LAYER: 'CHOROPLETH_COUNTRY_LAYER',
	CHOROPLETH_STATE_LAYER: 'CHOROPLETH_STATE_LAYER',
	//BOTTOM
};
